import { render, staticRenderFns } from "./IcNotification.vue?vue&type=template&id=325842ba&scoped=true"
import script from "./IcNotification.vue?vue&type=script&lang=js"
export * from "./IcNotification.vue?vue&type=script&lang=js"
import style0 from "./IcNotification.vue?vue&type=style&index=0&id=325842ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325842ba",
  null
  
)

export default component.exports